// Generated by purs version 0.15.7
import * as $foreign from "./foreign.js";
var runFn1 = function (f) {
    return f;
};
var mkFn1 = function (f) {
    return f;
};
export {
    mkFn0,
    mkFn2,
    mkFn3,
    mkFn4,
    mkFn5,
    mkFn6,
    mkFn7,
    mkFn8,
    mkFn9,
    mkFn10,
    runFn0,
    runFn2,
    runFn3,
    runFn4,
    runFn5,
    runFn6,
    runFn7,
    runFn8,
    runFn9,
    runFn10
} from "./foreign.js";
export {
    mkFn1,
    runFn1
};
